import { gql } from '__generated__';

export default gql(`
  mutation CancelOrder($id: ID!) {
    cancelOrder(id: $id) {
      id
    }
  }
`);
